import { lastNamesBase } from '../lib';
import { getRandomElementFromArray } from '../../../../../utils';

export function generateRandomLastName(): string {
    return getRandomElementFromArray(lastNamesBase);
}
